import MenuIcon from '@mui/icons-material/Menu';
import ModalNotify from 'components/common/Modal/ModalNotify';
import DrawerMenuLeft from 'components/drawer/DrawerMenuLeft';
import { indexOf } from 'lodash';
import APP_ACTION from 'model/actions/app';
import COMMON_ACTION from 'model/actions/common';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import ScrollToTop from 'react-scroll-up';
import { ToastContainer } from 'react-toastify';
import { getAuth, getPathName, setTimeoutLogin } from './functions';
import { setConfig } from './model/actions/config';
import { sendData } from './model/actions/functions';
import { commonConst } from './model/constants/actionConstants';
import Routes from './Routes';

import 'antd/dist/antd.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './patterns/css/icons/simple-line-icons.css';
import './patterns/css/wrapper.css';
import { PopupLoyalty } from 'components/common/Modal/PopupLoyalty';

class App extends Component {
  constructor() {
    super();
    this.setLayout = this.setLayout.bind(this);
    // history.listen((location, action) => {zz
    //   this.setLayout(location.pathname);
    // });

    this.state = {
      pathName: getPathName(),
      contentHeight: -1,
      isMoblie: window.innerWidth < 769,
      isPartnerLink: false,
      isVtStore: false,
    };
  }

  componentWillMount() {
    setTimeoutLogin();
    this.setLayout(this.props.pathname);
    this.getDataPartner();
  }

  componentWillUnmount() {
    console.log('componentWillUnmount');
  }

  getDataPartner = () => {
    const pathName = getPathName();
    if (pathName.indexOf('/pages/insurrance-online?productCode=') > -1) {
      this.setState({
        isPartnerLink: true,
      });

      const urlResult = decodeURI(pathName);
      const resultSp = urlResult.split('?');
      if (resultSp[1]) {
        const result = resultSp[1].split('&');

        let form = [];
        result.forEach((element) => {
          const item = element.split('=');

          if (item[0] === 'merchantCode') {
            if (item[1] === '2') {
              this.setState({
                isVtStore: true,
              });
            }
          } else {
            this.setState({
              [item[0]]: item[1],
            });
          }
        });
      }
    }
  };

  _onResize = () => {
    let contentHeight = this.state.contentHeight;
    if (document.getElementsByClassName('col main').length > 0) {
      contentHeight = document.getElementsByClassName('col main')[0].clientHeight;
    }
    this.setState({
      contentHeight: contentHeight,
      isMoblie: window.innerWidth < 769,
    });

    this.setLayout(getPathName());
  };

  onClick = () => {
    if (this.props.config.collapsed) this.props.setConfig('collapsed', false);
  };

  onClickMenu = (items) => {
    // SmartPhone: Đóng menu sau khi click
    if (window.innerWidth < 769) {
      this.props.setConfig('collapsed', !this.props.config.collapsed);
    }
    this.choseItem = items;
  };

  onClickHomePage = () => {
    // SmartPhone: Đóng menu sau khi click
    // PC: mở menu sau khi click
    this.choseItem = '';
    this.props.setConfig('collapsed', false);
  };

  setLayout(url) {
    const emptyView1 = [
      '/pages/error-page',
      '/pages/empty-page',
      '/pages/login',
      '/pages/update-password',
      '/pages/forgot-password',
    ];

    let isEmptyView = indexOf(emptyView1, url) !== -1 ? true : false;
    let currentLayout = this.props.config.layout;
    if (isEmptyView && currentLayout !== 'empty-view-1') {
      this.props.setConfig('layout', 'empty-view-1');
    } else if (!isEmptyView) {
      if (window.innerWidth < 1200) {
        this.props.setConfig('layout', 'default-sidebar-1');
      } else {
        this.props.setConfig('layout', 'top-navigation-1');
      }
    }
  }

  showFooter() {
    let showFooter = true;
    const pathName = getPathName();
    const pagesWithoutFooter = ['/customer/ekyc'];
    pagesWithoutFooter.forEach((item) => {
      if (pathName.includes(item)) {
        showFooter = false;
      }
    });
    return showFooter;
  }

  render() {
    let { layout, background } = this.props.config;
    let isEmptyView = layout === 'empty-view-1' ? true : false;
    const pathName = getPathName();
    let isLoginOrUpPwsd =
      pathName === '/pages/login' ||
      pathName === '/pages/update-password' ||
      pathName === '/pages/error-page' ||
      pathName === '/pages/empty-page' ||
      pathName === '/pages/forgot-password' ||
      pathName.includes('/customer/ekyc');

    let isDispBckgrd = isLoginOrUpPwsd || pathName === '/pages/error-page';

    const isPartnerLink = this.state.isPartnerLink;
    const isVtStore = this.state.isVtStore;
    const { notice, closeNotice } = this.props;

    const auth = getAuth();

    return (
      <div
        id='app'
        data-layout={layout}
        data-background={background}
        onClick={setTimeoutLogin}
        onChange={setTimeoutLogin}
      >
        {notice.isShow && (
          <ModalNotify
            afterClose={notice.afterClose}
            isShow={notice.isShow}
            onClose={closeNotice}
            content={notice.msg}
            type={notice.type}
          />
        )}

        <ToastContainer
          autoClose={6000}
          position={'top-right'}
          className={'toasClassName'}
          bodyClassName={'toastBody'}
        />
        {this.state.isMoblie && auth?.admin && (
          <>
            <div className='fixed left-10px top-13px z-50 flex h-30px w-30px items-center justify-center rounded-full bg-008BD2 shadow-menuDrawer'>
              <MenuIcon className='w-30px text-white' onClick={this.props.onShowDrawer} />
            </div>
            <DrawerMenuLeft
              showDrawer={this.props.visibleMenuDrawer}
              onCloseDrawer={this.props.onCloseDrawer}
            />
          </>
        )}

        <div className={isEmptyView ? '' : `container-fluid`}>
          <ReactResizeDetector handleWidth handleHeight onResize={() => this._onResize()} />
          {this.props.config.collapsed && !isDispBckgrd && (
            <div className='modal-bg' onClick={this.onClick} />
          )}
          <Routes isVtStore={isVtStore} isPartnerLink={isPartnerLink} />
        </div>

        <ScrollToTop showUnder={150} style={{ right: 15, zIndex: 3 }}>
          <span className='btn-scroll'>
            <i className='fa fa-chevron-up' aria-hidden='true' style={{ color: '#fff' }} />
          </span>
        </ScrollToTop>
        {this.props.popupLoyalty && <PopupLoyalty />}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    config: state.config,
    catMenuRed: state.CategoryMenuReducer,
    notice: state.common.notice,
    visibleMenuDrawer: state.app.visibleMenuDrawer,
    popupLoyalty: state.contract.popupLoyalty,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setConfig: (key, value) => dispatch(setConfig(key, value)),
    resetState: () => dispatch(sendData(commonConst.RESET_STATE, {})),
    closeNotice: () => dispatch(COMMON_ACTION.closeNotice()),
    onShowDrawer: () => dispatch(APP_ACTION.onShowDrawer()),
    onCloseDrawer: () => dispatch(APP_ACTION.onCloseDrawer()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
